import React, {InputHTMLAttributes} from 'react';
import {ErrorType} from '../../../utils/common';
// import minusIcon from '../../assets/minus.svg';
// import plusIcon from '../../assets/plus.svg';
// import QuestionTooltip from '../QuestionTooltip';
import {ErrorMessage} from '../../../styled/common';
import {Wrapper, StyledInput, Label, RelativeWrapper} from './styled';

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  invalid?: boolean;
  error?: ErrorType;
  hideNumberButtons?: boolean;
  labelTooltip?: string;
};

const defaultProps: InputProps = {
  onChange: undefined,
  label: '',
  invalid: undefined,
  error: '',
  hideNumberButtons: false,
  autoComplete: 'on',
};

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      value,
      onChange,
      className,
      label,
      invalid,
      defaultValue,
      disabled,
      name,
      type,
      max,
      error,
      hideNumberButtons,
      autoComplete,
      labelTooltip,
      ...props
    },
    ref,
  ) => {
    return (
      <Wrapper className={className} disabled={disabled}>
        <Label>{label}</Label>
        <RelativeWrapper>
          <StyledInput
            ref={ref}
            type={type}
            data-testid="input"
            value={value}
            onChange={onChange}
            invalid={invalid || Boolean(error)}
            disabled={disabled}
            defaultValue={defaultValue}
            aria-label={name}
            name={name}
            max={max}
            hideNumberButtons={hideNumberButtons}
            autoComplete={autoComplete}
            {...props}
          />
        </RelativeWrapper>

        {error && (
          <ErrorMessage className="error-message" data-testid={`${name}-error`}>
            {error}
          </ErrorMessage>
        )}
      </Wrapper>
    );
  },
);

Input.defaultProps = defaultProps;

export default Input;
